export enum TenantPlusModalOpenTrigger {
  CONTACT_FORM = 'contactForm',
  PHONE_NUMBER = 'phoneNumber',
  LISTER_PHONE_NUMBER = 'listerPhoneNumber',
  APPOINTMENT_VIEWING = 'appointmentViewing',
  REQUEST_ADDRESS = 'requestAddress',
  LISTING_STATS = 'listingStats',
  CRIF_MODAL = 'crifModal',
  BOTTOMSHEET = 'bottomsheet',
  MORE_IMAGES = 'moreImages',
  DESCRIPTION_CONTACT = 'desc_hide_contact',
}

export enum TenantPlusFeature {
  CONTACT_BLOCK = 'contactBlock',
  LISTING_DEMAND = 'listingDemand',
  EXCLUSIVE_IMAGES = 'exclusiveImages',
}
